export default __webpack_public_path__ + "static/media/close-o.1f272f14.svg";